import styles from './StatusDot.module.css';

interface Props {
  tone: 'success' | 'warning' | 'danger' | 'idle';
}

export function StatusDot({ tone }: Props) {
  return <span className={`${styles.dot} ${styles[tone]}`} aria-hidden="true" />;
}
